import {Observable} from 'rxjs';
import {CpmCKeycloakConfigApiSchema} from '../../schemas/c-global/cpmc-keycloak.api-schemas';
import {CpmCApiBridge} from '../../../../../src/app/cpmc-api-bridge';

/**
 * Keycloak Api Service
 */
export class CpmCKeycloakApiService {
    public static baseUrl() {
        return CpmCApiBridge.getBackendBaseURL() + '/api/core/v1/keycloak';
    }

    // ===============================================================
    // ===============================================================

    public static getConfig(): Observable<CpmCKeycloakConfigApiSchema> {
        return CpmCApiBridge.httpGet<CpmCKeycloakConfigApiSchema>(`${this.baseUrl()}/config`);
    }
}
